module.exports = ".list-unstyled {\n  padding-left: 0;\n  list-style: none; }\n\n.news-list li {\n  margin-bottom: 20px; }\n\n.news-list .post-title {\n  margin-bottom: 0;\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 1.6; }\n\n.text-muted {\n  color: #777;\n  font-size: 11px; }\n\n.color-grey {\n  color: #777; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/news-list-tabs/news-list-tabs.component.scss
// module id = ./src/app/modules/shared/components/news-list-tabs/news-list-tabs.component.scss
// module chunks = main